export default {
    // 买家中心
    "buyerWeb":'https://buyer.zengcaicloud.com',
    // 买家中心查看需求
    "buyerMess": 'https://buyer.zengcaicloud.com/#/demand',
    // 卖家中心
    "sellerWeb":'https://seller.zengcaicloud.com',
    // 设计师中心
    "designerWeb":'https://designer.zengcaicloud.com',
    // "designerWeb":'http://localhost:8081',
    // 评审中心
    "reviewWeb":'https://review.zengcaicloud.com',

    "payUrl":'https://www.zengcaicloud.com/resource-pay/pay/',
}



// WEBPACK FOOTER //
// ./src/utils/url.js